var React = require('react');

function File (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 10h6-6Zm0 4h6-6Zm8 5H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h5.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V17a2 2 0 0 1-2 2Z","stroke":"#1B1B1B","strokeOpacity":".3","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

File.defaultProps = {"className":"-case","width":"16","height":"20","fill":"none"};

module.exports = File;

File.default = File;
